module.exports = __webpack_public_path__ + "static/media/PyTorch.907fd1cb.svg";